module.exports = "https://www.ilove11.top/img/face79.5f8c4e40.gif";